"use client"

import { redirect, usePathname } from 'next/navigation'

import AuthController from '../controller/AuthController';
import AuthStorage from '../storage/AuthStorage';
import { verifySubdomainBase, verifyUser } from './ConfigSubdomain';

import React, { useState, useRef, useEffect } from 'react';

export default function PublicRoute({ component: Component, ...rest }) {

  console.log("publicaroute.j333s ",);

  //  let dataConfigSubdomain = authStorage.getConfigSubdomain();
  //  let { subdomain, idSuscripcion, idEmpresaInit, idiomaInit, urlLogoMenu } = dataConfigSubdomain;
  const [authStorage, setAuthStorage] = useState(undefined);


  let folderAPP = process.env.NEXT_PUBLIC_FOLDER_APP;


  useEffect(() => {

    verifySubdomainBase();

    const authStorage = new AuthStorage(window.location.pathname);
    let mewdataConfigSubdomain = authStorage.getConfigSubdomain();

    setAuthStorage(authStorage);
    //setDataConfigSubdomain(mewdataConfigSubdomain);

    let e = "";
  }, []);

  if (typeof window !== 'undefined' && authStorage !== undefined) {

    //let newPath = window.location.pathname;
    let newPath = folderAPP + "/home";

    //console.log("component, ", Component);
    if (authStorage.esLocalStorage === false) {

      return (

        <Component />

      );

    }
    else {

      if (!verifyUser()) {
        newPath = folderAPP + "/";
      }

      if ("")
        redirect(newPath)


      return (
        <>
          {"" ? (
            <></>
          ) :
            (
              <Component />
            )
          }
        </>
      );

    }

  }
  else
    return (<></>);


}
